
import { AutoMap } from "@automapper/classes";
import { EMesureTerrainStatus } from "./enums/mesure-terrrain-status";

export class ProcessMeasure {
    @AutoMap()
    SamplingId!: number;
    @AutoMap()
    Code!: string;
    @AutoMap()
    IsCancelled!: boolean;
    @AutoMap()
    MeasureReferenceCode!: string;
    @AutoMap()
    MeasureReferenceName!: string;
    @AutoMap()
    Status!: EMesureTerrainStatus;
    @AutoMap()
    Localisation!: string;
    @AutoMap()
    TextColor!: string;
    @AutoMap()
    Color!: string;
    @AutoMap()
    Observation?: string;
    @AutoMap()
    SampleCode?: string;
    public constructor(init?: Partial<ProcessMeasure>) {
        Object.assign(this, init);
    }
}